// removed by extract-text-webpack-plugin
module.exports = {"navList":"navList--bc587"};